
import { useEffect } from "react";

const DEFAULT_FAVICON = "/images/home_images/Logo_Transparent.png";

export default function useFavicon(href: string | null | undefined): void {
  useEffect(() => {
    if (!href) return;

    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = href;

    return () => {
      link.href = DEFAULT_FAVICON;
    };
  }, [href]);
}

